import React, { memo, useState, useContext, useRef, useEffect } from 'react'
import {
  Button,
  Link,
  DropdownMenu,
  HeadingText,
  Tooltip,
  TextInput,
  TextArea,
  CaptionText,
  Alert,
} from '@paypalcorp/pp-react'
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react'
import { MessageFormat } from '@paypalcorp/worldready'
import ReCAPTCHA from 'react-google-recaptcha'
import { isEmail, isEmptyOrWhiteSpace } from '../../../utils/validation'
import {
  serverData,
  fptiCustomSetup,
  fptiCustomClick,
  getFeatureValue,
} from '../../../utils'

import { ZETTLE_SUBMIT_API } from '../../../constants/constants'
import { post } from '../../../utils/ajax.js'
import DsrBanner from '../common/dsr-banner'
import Spinner from '../common/dsr-spinner'

const dsrRecaptchaKey = getFeatureValue('dsrRecaptchaSiteKey')
const recaptchaFlag = getFeatureValue('recaptchaFlagToDisplay')

const optionsToData = [
  {
    primaryText: <Message id="dsrZettle.form.common.right.to.erasure" />,
    value: 'DATA_ERASURE',
  },
  {
    primaryText: <Message id="dsrZettle.form.common.right.to.access" />,
    value: 'DATA_ACCESS_REQUEST',
  },
  {
    primaryText: <Message id="dsrZettle.form.common.right.to.be.informed" />,
    value: 'DATA_INFORMATION',
  },
  {
    primaryText: (
      <Message id="dsrZettle.form.common.right.to.data.processing" />
    ),
    value: 'DATA_RESTRICTION',
  },
  {
    primaryText: (
      <Message id="dsrZettle.form.common.right.to.data.portability" />
    ),
    value: 'DATA_PORTABILITY',
  },
  {
    primaryText: <Message id="dsrZettle.form.common.right.to.correction" />,
    value: 'DATA_CORRECTION',
  },
]

const userObj = {
  fname: '',
  lname: '',
  requestType: '',
  email: '',
  correctionData: '',
  captchaToken: '',
}

let validateObj = { ...userObj }

const DataRequestForm = memo((props) => {
  const worldReady = useContext(WorldReadyContext)
  const [selectedItem, setSelectedItem] = useState()
  const [comments, setComments] = useState(false)
  const [isErrOnWhatdata, setErrOnWhatdata] = useState(false)
  const [isErrOnFname, setErrOnFname] = useState(false)
  const [isErrOnLname, setErrOnLame] = useState(false)
  const [isErrOnEmail, setErrOnEmail] = useState(false)
  const [isErrOnCaptcha, setErrOnCaptcha] = useState(false)
  const [isErrOnComments, setErrOnComments] = useState(false)
  const [isErrOnMaxLimitComments, setErrOnMaxLimitComments] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)
  const [impressionDone, setImpressionDone] = useState(false)
  const [formValues, setFormValues] = useState(userObj)

  const maxCharacters = 250
  const { dsrFpti = {} } = props
  const recaptchaRef = useRef(null)
  window.recaptchaOptions = {
    useRecaptchaNet: true,
  }

  const validateFields = () => {
    const reqTypeEle = isEmptyOrWhiteSpace(userObj.requestType)
    const fnameEle = isEmptyOrWhiteSpace(userObj.fname)
    const lnameEle = isEmptyOrWhiteSpace(userObj.lname)
    const emailEle = isEmptyOrWhiteSpace(userObj.email)
    const captchaEle = isEmptyOrWhiteSpace(userObj.captchaToken)
    const isvalidEmail = isEmail(userObj.email)

    validateObj = {
      fname: fnameEle,
      lname: lnameEle,
      requestType: reqTypeEle,
      captcha: captchaEle,
    }

    setErrOnWhatdata(reqTypeEle)
    setErrOnFname(fnameEle)
    setErrOnLame(lnameEle)
    setErrOnCaptcha(captchaEle)
    if (emailEle) {
      validateObj = {
        ...validateObj,
        email: emailEle,
      }
      setErrOnEmail(emailEle)
    } else {
      validateObj = {
        ...validateObj,
        email: isvalidEmail,
      }
      setErrOnEmail(isvalidEmail)
    }

    if (comments) {
      const commentsEle = isEmptyOrWhiteSpace(userObj.correctionData)
      validateObj = {
        ...validateObj,
        correctionData: commentsEle,
      }
      setErrOnComments(commentsEle)
    }
  }
  async function postDARRequest(reqparams) {
    fptiCustomClick(dsrFpti.SUBMIT_BTN)
    setShowSpinner(true)
    const response = await post(ZETTLE_SUBMIT_API, reqparams)
    if (response && response.success) {
      setShowAlert(false)
      props.changeState('SUCCESS')
    } else {
      setShowSpinner(false)
      setShowAlert(true)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setShowAlert(false)

    if (recaptchaFlag) {
      const ctoken = recaptchaRef.current.getValue()
      userObj.captchaToken = ctoken
    } else {
      userObj.captchaToken = 'testvalue'
    }

    validateFields()
    const isValid = Object.keys(validateObj).some(
      (item) => validateObj[item] === true,
    )
    const reqparams = {
      _csrf: serverData._csrf,
      fields: JSON.stringify(userObj),
    }

    if (!isValid) {
      postDARRequest(reqparams)
    }
  }

  const handleSelection = (event) => {
    userObj.correctionData = ''
    if (event.target.value === 'DATA_CORRECTION') {
      setComments(true)
    } else {
      setComments(false)
    }
    userObj.requestType = event.target.value
    setSelectedItem(event.target.value)
  }

  const handleChange = (evt) => {
    userObj[evt.target.name] = evt.target.value

    if (comments) {
      setErrOnMaxLimitComments(evt.target.value.length > maxCharacters)
    } else {
      setErrOnMaxLimitComments(false)
    }
  }

  const ddmenuAccessLable = new MessageFormat(worldReady, {
    id: 'dsrZettle.form.common.right.to.ex.label',
  }).format()

  const getErrorText = () => {
    let text = ''
    if (isErrOnComments) {
      text = (
        <Message id="dsrZettle.form.common.info.to.correct.validation.required" />
      )
    } else if (isErrOnMaxLimitComments) {
      text = (
        <Message id="dsrZettle.form.common.info.to.correct.validation.max.length.250" />
      )
    }
    return text
  }
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(dsrFpti.CASECREATION_IMPRESSION)
    }
    setFormValues(userObj)
  }, [impressionDone, dsrFpti])
  const bannerContent = {
    header: <Message id="dsrZettle.landing.header.title" />,
    description: <Message id="dsrZettle.landing.header.description" />,
  }
  const onClickPrivacyLink = () => {
    fptiCustomClick(dsrFpti.PRIVACY_LINK)
  }
  return (
    <>
      {showSpinner && <Spinner />}
      {!showSpinner && (
        <>
          <DsrBanner {...bannerContent} />
          <section className="page-body-container">
            <div className="inner-container">
              <section className="data-request-page">
                <HeadingText size="sm">
                  <Message id="dsrZettle.form.body.title" />
                </HeadingText>

                <form className="darform">
                  {showAlert && (
                    <Alert
                      className="requestForm-row"
                      type="error"
                      closeButton={{
                        onClick: () => {
                          setShowAlert(false)
                        },
                      }}
                    >
                      <Message id="dsrZettle.common.error.technical" />
                    </Alert>
                  )}{' '}
                  <div>
                    <DropdownMenu
                      id="zettle_dd"
                      name="what-data"
                      label={ddmenuAccessLable}
                      errorText={
                        isErrOnWhatdata ? (
                          <Message id="dsrZettle.form.common.right.to.ex.validation.required" />
                        ) : (
                          ''
                        )
                      }
                      value={selectedItem}
                      options={optionsToData}
                      onChange={handleSelection}
                    />
                  </div>
                  {comments && (
                    <div>
                      <section>
                        <TextArea
                          name="correctionData"
                          label={
                            <Message id="dsrZettle.form.common.info.to.correct.placeholder" />
                          }
                          defaultValue={formValues && formValues.correctionData}
                          onChange={handleChange}
                          showCharacterCounter
                          maxCharacters={maxCharacters}
                          errorText={getErrorText()}
                          rightIcon={
                            <Tooltip
                              description={
                                <Message id="dsrZettle.form.common.info.to.correct.tooltip" />
                              }
                              className="comments-tooltip-icon"
                            />
                          }
                        />
                      </section>
                    </div>
                  )}
                  <div>
                    <TextInput
                      name="fname"
                      label={
                        <Message id="dsrZettle.form.common.first.name.label" />
                      }
                      defaultValue={formValues && formValues.fname}
                      onChange={handleChange}
                      errorText={
                        isErrOnFname ? (
                          <Message id="dsrZettle.form.common.first.name.validation.required" />
                        ) : (
                          ''
                        )
                      }
                    />
                  </div>
                  <div>
                    <TextInput
                      name="lname"
                      label={
                        <Message id="dsrZettle.form.common.last.name.label" />
                      }
                      defaultValue={formValues && formValues.lname}
                      onChange={handleChange}
                      errorText={
                        isErrOnLname ? (
                          <Message id="dsrZettle.form.common.last.name.validation.required" />
                        ) : (
                          ''
                        )
                      }
                    />
                  </div>
                  <div>
                    <TextInput
                      name="email"
                      label={<Message id="dsrZettle.form.common.email.label" />}
                      onChange={handleChange}
                      defaultValue={formValues && formValues.email}
                      errorText={
                        isErrOnEmail ? (
                          <Message id="dsrZettle.form.common.email.validation.required" />
                        ) : (
                          ''
                        )
                      }
                    />
                  </div>
                  {recaptchaFlag && (
                    <div className="zettle-captcha-center">
                      <div>
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={dsrRecaptchaKey.sitekey || ''}
                        />

                        {isErrOnCaptcha ? (
                          <div
                            className="ppvx_text-input__error-text___3-12-10 ppvx_text-input__error-icon___3-12-10"
                            role="alert"
                          >
                            <Message id="dsrZettle.form.captcha.required" />
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  )}
                  <div className="text-center">
                    <Button id="submitbtn" onClick={handleSubmit}>
                      <Message id="dsrZettle.form.common.submit.btn" />
                    </Button>
                  </div>
                </form>
                <div>
                  <CaptionText className="text-center">
                    <Message
                      id="dsrZettle.form.common.terms.and.conditions"
                      link={(innerMessage) => (
                        <Link
                          href={`https://${serverData.cdnPayPalDomain}/en/webapps/mpp/ua/privacy-full#3`}
                          onClick={onClickPrivacyLink}
                          id="privacy_statment_link"
                        >
                          {innerMessage}
                        </Link>
                      )}
                    />
                  </CaptionText>
                </div>
              </section>
            </div>
          </section>
        </>
      )}
    </>
  )
})
DataRequestForm.displayName = 'DataRequestForm'

export default DataRequestForm
